"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["ascending"] = 0] = "ascending";
    SortDirection[SortDirection["descending"] = 1] = "descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=sortable-table.types.js.map